import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CsvExportParams, GridApi } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';
import { InputColumnFilterUserComponent } from 'src/app/certificates/components/input-column-filter-user/input-column-filter-user.component';
import { CheckboxFilterUsersComponent } from 'src/app/certificates/components/checkbox-filter-users/checkbox-filter-users.component';
import { CheckboxFilterCertificateComponent } from 'src/app/certificates/components/checkbox-filter-certificate/checkbox-filter-certificate.component';
import { InputColumFilterCertificateComponent } from 'src/app/certificates/components/input-colum-filter-certificate/input-colum-filter-certificate.component';
import { FiltersService } from 'src/app/shared/services/filters.service';
import { GridService } from 'src/app/shared/services/grid-defs.service';

@Component({
  selector: 'ng-grid-arm-certificate-list',
  templateUrl: './grid-arm-certificate-list.component.html',
  styleUrls: ['./grid-arm-certificate-list.component.scss']
})
export class GridArmCertificateListComponent implements OnInit {

  @Input() rowData: any;
  @Input() paginationAutoPageSize: any;
  @Input() suppressRowClickSelection: any;
  @Input() pagination: any;
  @Input() type: string;
  @Input() downloadParams: CsvExportParams;
  @Output() openModal = new EventEmitter();

  @Output() numberOfSelectedRows = new EventEmitter<number>();
  context: any;
  form: FormGroup;
  defaultColDef = {
    sortable: true,
    filter: true
  };
  selectedRows = 0;
  objectDefs: any;
  gridApi: GridApi;
  columnApi: any;
  columnFilter = [];

  filterGroup = {
    certificates: {
      checkboxCertificateFilterComponent: CheckboxFilterCertificateComponent,
      inputColumnCertificateFilterComponent: InputColumFilterCertificateComponent
    },
    users: {
      checkboxFilterComponent: CheckboxFilterUsersComponent,
      inputColumnFilterComponent: InputColumnFilterUserComponent
    }
  };

  constructor(
    private router: Router,
    public filtersService: FiltersService,
    public gridService: GridService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) {
    this.filtersService.fitFilters().subscribe(data => {
      // console.log(data);
    });
    this.context = {
      componentParent: this,
      form: this.form,
    }
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
    this.columnFilter = this.gridService[this.type].map(col => {
      return {
        headerName: col.headerName,
        value: col.field,
        checked: col.field === 'id' ? false : true
      };
    });
    this.addCheckboxes();
  }

  addCheckboxes() {
    this.columnFilter.forEach(column => {
      const control = new FormControl(column.checked);
      (this.form.controls.orders as FormArray).push(control);
    });
  }

  onClickRequest(row) {
    const id = row.data.id;
    this.router.navigate(['home/certificates/arm/edit', row.data.country.code]);
  }

  onRowSelected(event) {
    if (event.node.selected) {
      this.selectedRows++;
    } else {
      this.selectedRows--;
    }
    this.numberOfSelectedRows.emit(this.selectedRows);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', () => {
      setTimeout(() => params.api.sizeColumnsToFit());
    });
  }

  onBtExport() {
    this.gridApi.exportDataAsCsv(this.downloadParams);
  }

  onRowClicked(row: any) {
    const code = row.data.country.code;
    this.router.navigate(['home/' + this.type, code]);
  }
  onOpen(event) {
    console.log(event)


    // let rows:any[] = (JSON.parse(localStorage.getItem("rowData")));

    // this.gridApi.setRowData(rows)// .setRowData(rows);
    this.openModal.emit('openModal');
    // this.findCertificates();
  }
}
